import { CashValueByCashType } from "@/model/data/branchReport/CashValueByCashType";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetBackOfficeTotalsByInstallationResData extends ServiceResponseData {

    /**Somma di tutti gli importi (suddivisi in banconote e monete) che sono stati inviati da macchine di back office all'installazione di front office specificata */
    public fromOtherOffice: CashValueByCashType;

    /**Somma di tutti gli importi (suddivisi in banconote e monete) che sono stati ricevuti in macchine di back office da parte dell'installazione di front office specificata */
    public toOtherOffice: CashValueByCashType;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {

        if (obj.FromOtherOffice) {
            this.fromOtherOffice = new CashValueByCashType();
            this.fromOtherOffice.parse(obj.FromOtherOffice);
        }

        if (obj.ToOtherOffice) {
            this.toOtherOffice = new CashValueByCashType();
            this.toOtherOffice.parse(obj.ToOtherOffice);
        }
    }
}